import { OktaTokenStorage } from '../types';
import { OktaAuth } from '@okta/okta-auth-js';

/**
 * Checks okta-token-storage local storage item idToken payload expiration against the current time
 * @param oktaAuth
 * @returns {Promise<boolean>} returns promise, true if expired, false if not
 */
export const tokenHasExpired = async (responseStatus: number, oktaAuth: OktaAuth): Promise<boolean> => {
  if (responseStatus === 401) {
    console.log('Token expired. Removing token from cache and refreshing (401)');
    await oktaAuth.tokenManager.clear();
    window.location.reload();
  }
  const rawToken = await localStorage.getItem('okta-token-storage');

  if (rawToken) {
    const { idToken }: OktaTokenStorage = JSON.parse(rawToken);
    // if (!idToken) {
    //   await oktaAuth.tokenManager.clear();
    //   window.location.reload();
    // }

    if (idToken && idToken.expiresAt) {
      const isExpired = Date.now() >= idToken.expiresAt * 1000;
      if (isExpired) {
        console.log('Token expired. Removing token from cache and refreshing');
        await oktaAuth.tokenManager.clear();
        window.location.reload();
      } else if (oktaAuth?.tokenManager && Date.now() < idToken.expiresAt * 1000) {
        await oktaAuth?.tokenManager.renew('idToken');
      }
    }
    return true;
  }
  return true;
};
